import { useState } from 'react';
import { X, Bell } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Create Alert Modal - Set price alerts for stocks
 */
export function CreateAlertModal({ stock, isOpen, onClose }) {
  const [targetPrice, setTargetPrice] = useState(stock?.price?.toFixed(2) || "");
  const [notifyType, setNotifyType] = useState("once");

  if (!isOpen) return null;

  const handleSetAlert = () => {
    if (!targetPrice || parseFloat(targetPrice) <= 0) {
      toast.error("Please enter a valid target price");
      return;
    }
    toast.success(`Price alert set for ${stock?.symbol} at ₹${targetPrice}`);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onClose}>
      <div className="bg-white rounded-xl w-[380px] shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="create-alert-modal">
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <Bell size={18} className="text-[#387ed1]" />
            <span className="font-semibold text-gray-900">Set Alert — {stock?.symbol}</span>
          </div>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-100" data-testid="close-alert-modal">
            <X size={18} className="text-gray-400" />
          </button>
        </div>

        <div className="p-5 space-y-5">
          <div className="text-sm text-gray-500">
            Current Price: <span className="font-medium text-gray-900">₹{stock?.price?.toFixed(2)}</span>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Target Price</label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">₹</span>
              <input
                type="number"
                value={targetPrice}
                onChange={(e) => setTargetPrice(e.target.value)}
                className="w-full pl-7 pr-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:border-[#387ed1] focus:ring-1 focus:ring-[#387ed1]/20 outline-none"
                placeholder="Enter target price"
                data-testid="alert-target-price"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Notify me</label>
            <div className="flex gap-3">
              {[
                { value: "once", label: "Once" },
                { value: "everytime", label: "Every time" },
              ].map(({ value, label }) => (
                <button
                  key={value}
                  onClick={() => setNotifyType(value)}
                  className={`flex-1 py-2 text-sm font-medium rounded-lg border transition-colors ${
                    notifyType === value
                      ? "border-[#387ed1] text-[#387ed1] bg-[#387ed1]/5"
                      : "border-gray-200 text-gray-500 hover:border-gray-300"
                  }`}
                  data-testid={`alert-notify-${value}`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          <button
            onClick={handleSetAlert}
            className="w-full py-2.5 text-sm font-semibold rounded-lg text-white bg-[#387ed1] hover:bg-[#2d6bb8] transition-colors"
            data-testid="set-alert-btn"
          >
            SET ALERT
          </button>
        </div>
      </div>
    </div>
  );
}
